var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("@/static/personalCenter/feedback.png")

  var l0 = _vm.__map(_vm.myComplainList, function(item, index) {
    var m1 = _vm.formatTime(item.publishTime)
    return {
      $orig: _vm.__get_orig(item),
      m1: m1
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }